import React, {useState} from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import galleryIcon from './../../../../../../assets/icons/gallery.png'
import Cancel from './../../../../../../assets/icons/close.png'
import Typography from '@mui/material/Typography'
import AutoCompleteMultiSelect from './../../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CancelIcon from '@mui/icons-material/Cancel'
import TextAreaComponents from './../../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import AddSectionDialog from '../../../AddSectionDialog.tsx';
import plusIcon from './../../../../../../assets/icons/plus.png'

function AddFoodHistotyItemDialog(props) {
//dialog start
const [openAddSection, setOpenAddSection] = useState(false);
const [dialogType, setDialogType] = useState('');


const handleClickOpen = () => {
    setOpenAddSection(true);
    setDialogType('add');
  }

  const handleAddItem = (AddSectionData) => {
    setOpenAddSection(AddSectionData)
  }

//dialog end

    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const sectionDatas = [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
    ]
    const [Item, setItem] = React.useState("");
    const addValue = (props) => {
        console.log(props)
        setItem(props)
    }
    const [addons, setAddons] = React.useState([]);
    const addaddons = (props) => {
        console.log(props)
        setAddons(props)
    }
    const [state, setState] = React.useState<ImageUploadState>({
        selectedImages: [],
    })

    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files
        if (files) {
            const imagesArray: string[] = []
            const remainingSlots = 5 - state.selectedImages.length
            const filesToUpload = Array.from(files).slice(0, remainingSlots)
            for (let i = 0; i < filesToUpload.length; i++) {
                const file = filesToUpload[i]
                const reader = new FileReader()
                reader.onloadend = () => {
                    imagesArray.push(reader.result as string)
                    if (imagesArray.length === filesToUpload.length) {
                        const updatedImages = [...state.selectedImages, ...imagesArray]
                        setState({ selectedImages: updatedImages })
                    }
                }
                reader.readAsDataURL(file)
            }
        }
    }

    const handleDeleteImage = (index: number) => {
        const updatedImages = [...state.selectedImages]
        updatedImages.splice(index, 1)
        setState({ selectedImages: updatedImages })
    }
    const saveData = () => {
        const values = {
            ItemName: quantity,
            Details: portionSize,
            Images: galleryIcon
        }
        props.onHandleAddItem(values)
    }
    const [quantity, setquantity] = React.useState("");
    const textFieldValue = (props) => {
        console.log(props)
        setquantity(props);
    }
    const [portionSize, setportionSize] = React.useState("");
    const portionSizeValue = (props) => {
        console.log(props)
        setportionSize(props);
    }
    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>Add Food History sections</DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>

                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Section Name
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={'Section Name'} value={textFieldValue} />

                            </Grid>
                            <Grid item xs={2} className="" onClick={handleClickOpen}>
                                {/* <img src={plusIcon} alt="+" onClick={handleClickOpen} /> */}
                                <button className='modalAddButton'>+Add Section</button>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Details
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={'Details'} value={portionSizeValue} id={1} />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Banner Image
                                </Typography>
                            </Grid>
                            <Grid xs={9}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    //   color="primary"
                                    style={{ backgroundColor: 'white', color: 'gray' }}
                                >
                                    <img
                                        src={galleryIcon}
                                        alt="photo"
                                        style={{ width: '2rem' }}
                                    />
                                    Upload
                                    <input
                                        hidden
                                        accept="image/*"
                                        multiple
                                        type="file"
                                        onChange={handleImageUpload}
                                        disabled={state.selectedImages.length === 1}
                                    />
                                </Button>
                            </Grid>

                            {/* image show start */}
                            <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={9}>
                                    <Grid container spacing={2}>
                                        {state.selectedImages.map((image, index) => (
                                            <Grid item xs={2} sm={2} md={2} key={index}>
                                                {/* <Paper> */}
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        paddingTop: '20px',
                                                    }}
                                                >
                                                    <img
                                                        src={image}
                                                        alt={`Preview ${index + 1}`}
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            objectFit: 'cover',
                                                        }}
                                                    />
                                                    <IconButton
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-6px',
                                                            right: '-23px',
                                                            color: 'gray',
                                                        }}
                                                        onClick={() => handleDeleteImage(index)}
                                                    >
                                                        <CancelIcon />
                                                    </IconButton>
                                                </div>
                                                {/* </Paper> */}
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* image show end */}
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="AddItemButtons" onClick={() => saveData()}>Save</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
            <AddSectionDialog open={openAddSection}
        dialogType={'Add Section'} onHandleAddItem={handleAddItem}  />
        </div>
    );
}

export default AddFoodHistotyItemDialog;